module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-No-Pagebreak"
  }, [_vm._v("4")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_c('span', {
    staticClass: "orim-drop-cap"
  }, [_vm._v("W")]), _vm._v("hen Vail walked into her house at 3:30 "), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("AM")]), _vm._v(", her chocolate brown Standard Poodle puppy, Hershey, greeted her at the door. He stood up on his back legs and bathed her face with kisses. She gave him a piece of duck jerky and found Robby asleep on the couch, a bag of Trader Joe’s spicy flax seed chips on the coffee table perched beside an empty hummus container.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("She inched her left buttock onto the edge of the seat cushion beside his thigh and stroked his face. His eyes fluttered open.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What time is it?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Very late at night or very early in the morning. Depends on your perspective.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He sat up and hung his head. “I was dreaming.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“About me?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Right answer. C’mon, let’s get you to bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Hershey followed them into the bedroom and hopped onto the mattress as Robby stepped up to the adjacent vanity and pulled open his drawer. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“So why did I have to leave? And what the hell is going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Vail had been dreading such a question, which she knew would be among the first he asked. “Look, when you’re undercover, you can’t talk about the case, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He popped open the cap on the toothpaste. “What’s that got to do with this? You don’t work undercover.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I can’t say any more.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He stood there, the tube in his right hand and the brush in his left. His brain was not fully awake yet so it was taking him longer to put it together. He set the toothpaste down. “You’re telling me you’re undercover?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Vail started removing the makeup she had put on before she and Robby had left for the evening. She glanced at him in the mirror and he seemed to get it: she could not talk about it. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He went back to his teeth, then spit and rinsed his brush. “Is it dangerous?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Vail thought about that, about her run-in with the terrorist tonight, about what Uzi had said about how she had handled it. “Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Robby set the brush down and looked at her image in the mirror. He apparently decided against commenting. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("What can he say? His undercover ops with DEA are dangerous too.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t like it when the shoe’s on the other foot.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Vail tossed the cotton cleansing pad in the garbage. “I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Line-Break"
  }, [_vm._v("VAIL ARRIVED at the Behavioral Analysis Unit at 8:30 "), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("AM")]), _vm._v("—and found a note on her desk from Lenka, the administrative staff for her boss, Assistant Special Agent in Charge Thomas Gifford.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Rather than lifting the phone, she walked over to Lenka’s desk.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Agent Vail. I left a note—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Vail held it up. “Found it. Boss wants to see me?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lenka nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He pissed about something?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lenka nodded again, then buzzed Gifford and told him Vail was there. “Go on in.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Vail pushed through the door and Gifford motioned her to sit.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I got a strange call this morning,” Gifford said, “from Liz Evanston. Do you know who Liz Evanston is?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Not even a hello. Yeah, he’s pissed all right.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Your ex-wife?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He didn’t say any more, so Vail asked, “If this is twenty questions, sir, can I have a pad and pen?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“She’s Director Knox’s executive assistant.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("She raised both hands, palms up. “You just ruined the game. I had at least another nineteen guesses left.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“She had a message for me. From the director. And it was about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Right. Now I understand why I’m sitting in your office.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, that makes one of us. I was told that you’re on special assignment. But when I asked for clarification and details—like how long this assignment would last—she said she didn’t know. When I asked if I should reassign your active cases, she said, ‘Probably’.” He leaned forward and rested both forearms on his desk. “Now your unit chief and I have the BAU to run, with a lot of cases and very few agents. As hard as it is for me to admit it, you’re one of my best analysts. So when you’re removed from the equation, I kind of have to know why, and for how long.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, you don’t really have to know "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("why")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Gifford looked at her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I’m just saying. ‘Why’ isn’t releva—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Karen,” he said through clenched teeth. “What the hell is going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I can’t go into it. But I do need to be excused from my duties for the foreseeable future. I’ll be working offsite.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I’m your ASAC. And that’s not an acceptable answer. Where are you getting your orders?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t think I can say.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Gifford frowned, hiked his brow, then grabbed a file off his desk. “Then no, you can’t be excused from your duties.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But—” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Before she could finish her sentence, Gifford’s line buzzed. He hit the intercom. “Lenka, hold my calls.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It’s Director Knox, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Gifford glanced at Vail, as if he was starting to put it together. “Put him through,” he said in the direction of the speaker, then lifted the handset. Vail started to rise but Gifford motioned her down. “Mr. Director.” He listened for a bit, his face flushing, then looked at Vail again. It was not a pleasant expression. Finally, he said, “Sir, how can I run my unit without—” The jaw muscles in his face tightened. “The good of the country. Yes sir, I understand … Yes sir, I will do that … No, we’ll manage … Yes. Thank you, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("As Gifford set the handset back in the cradle, Vail slapped her thighs. “Okay, then. We’re good?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Gifford steepled his fingers, his eyes locked with Vail’s.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“If it helps, sir, I’m not enjoying this.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t believe you. And it most certainly does not help. What am I supposed to do with all your cases?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“If I were the ASAC, I’d reass—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That was a rhetorical question.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Right.” Vail rose from her seat. She started to leave, then stopped with a hand on the knob. “You have your orders, sir. And I have mine. Neither of us are happy about it. How about we leave it at that?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Gifford did not reply, so she pulled the door open and left.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48b5d1e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Jacobson_LostCodex_1P-7.vue
// module id = 93
// module chunks = 0